module.exports = __webpack_public_path__ + "media/flags/va-65c2b191.gif";